import React from 'react';
import Link from 'components/shared/Link';
import {
  makeStyles, Button,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  getStarted: {
    padding: theme.spacing(0.75, 5),
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(1.5, 6.75),
    },
  },
}));

const GetStartedBtn = ({ i18n, styleClass }) => {
  const classes = useStyles();
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        disableElevation
        classes={{ root: `${styleClass || classes.getStarted}` }}
        component={Link}
        href="/user/vehicles"
      >
        {i18n('fe_list_your_bike:get_started')}
      </Button>
    </>
  );
};

export default GetStartedBtn;
